import React from 'react';
import { Link } from 'react-router-dom';

const ContactPage: React.FC = () => {
  return (
    <main style={{ paddingTop: 100 }}>
      <div className="container" style={{ maxWidth: 640, margin: '0 auto', padding: '60px 24px 80px' }}>
        <div style={{ marginBottom: 48, textAlign: 'center' }}>
          <h1 style={{ fontSize: 'clamp(1.8rem, 4vw, 2.5rem)', fontWeight: 900, marginBottom: 12 }}>Contact Us</h1>
          <p style={{ color: '#94a3b8', fontSize: '1rem', lineHeight: 1.7 }}>
            Have a question, refund request, or privacy inquiry? Fill in the form below and our team will get back to you.
          </p>
        </div>

        <div style={{
          background: '#1e293b',
          border: '1px solid rgba(148,163,184,0.15)',
          borderRadius: 16,
          padding: '40px 32px',
        }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>

            <div>
              <label style={{ display: 'block', color: '#94a3b8', fontSize: '0.85rem', fontWeight: 600, marginBottom: 8, textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                Inquiry Type
              </label>
              <select style={{
                width: '100%',
                background: '#0f172a',
                border: '1px solid rgba(148,163,184,0.2)',
                borderRadius: 8,
                padding: '12px 16px',
                color: '#f9fafb',
                fontSize: '0.95rem',
                outline: 'none',
                cursor: 'pointer',
              }}>
                <option value="general">General Question</option>
                <option value="refund">Refund Request</option>
                <option value="privacy">Privacy / Data Request</option>
              </select>
            </div>

            <div>
              <label style={{ display: 'block', color: '#94a3b8', fontSize: '0.85rem', fontWeight: 600, marginBottom: 8, textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                Your Email
              </label>
              <input
                type="email"
                placeholder="you@example.com"
                style={{
                  width: '100%',
                  background: '#0f172a',
                  border: '1px solid rgba(148,163,184,0.2)',
                  borderRadius: 8,
                  padding: '12px 16px',
                  color: '#f9fafb',
                  fontSize: '0.95rem',
                  outline: 'none',
                  boxSizing: 'border-box',
                }}
              />
            </div>

            <div>
              <label style={{ display: 'block', color: '#94a3b8', fontSize: '0.85rem', fontWeight: 600, marginBottom: 8, textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                Message
              </label>
              <textarea
                rows={5}
                placeholder="Describe your inquiry..."
                style={{
                  width: '100%',
                  background: '#0f172a',
                  border: '1px solid rgba(148,163,184,0.2)',
                  borderRadius: 8,
                  padding: '12px 16px',
                  color: '#f9fafb',
                  fontSize: '0.95rem',
                  outline: 'none',
                  resize: 'vertical',
                  boxSizing: 'border-box',
                  fontFamily: 'inherit',
                }}
              />
            </div>

            <div style={{
              background: 'rgba(37,99,235,0.1)',
              border: '1px solid rgba(37,99,235,0.25)',
              borderRadius: 8,
              padding: 14,
              color: '#93c5fd',
              fontSize: '0.85rem',
              lineHeight: 1.6,
            }}>
              🤖 Our AI assistant reviews every inquiry and provides an initial response based on our policies. Complex cases are escalated to our team.
            </div>

            <button
              style={{
                background: 'linear-gradient(135deg, #2563eb, #22c55e)',
                border: 'none',
                borderRadius: 8,
                padding: '14px 24px',
                color: '#fff',
                fontSize: '1rem',
                fontWeight: 700,
                cursor: 'pointer',
                width: '100%',
              }}
            >
              Submit Inquiry
            </button>

          </div>
        </div>

        <p style={{ textAlign: 'center', marginTop: 32, color: '#64748b', fontSize: '0.85rem' }}>
          <Link to="/" style={{ color: '#60a5fa' }}>← Back to home</Link>
        </p>
      </div>
    </main>
  );
};

export default ContactPage;
